module.exports = __webpack_public_path__ + "img/reggea.b7432031.jpg";